import { render, staticRenderFns } from "./getTimeElectricshock.vue?vue&type=template&id=4738a2d0&scoped=true&"
import script from "./getTimeElectricshock.vue?vue&type=script&lang=js&"
export * from "./getTimeElectricshock.vue?vue&type=script&lang=js&"
import style0 from "./getTimeElectricshock.vue?vue&type=style&index=0&id=4738a2d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4738a2d0",
  null
  
)

export default component.exports